<template>
    <div id="container">

        <div id="map_view">
            <div id="edit_view">
                <!-- <el-button type="success" size="small" @click.stop="switchToSatelliteMap()"
                    style="background-color: #3CA757;color: #FFFFFF;">卫星地图</el-button> -->
                <div style="display: flex; flex-direction: column; align-items: center; margin-right: 10px;">
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <el-button size="small" @click.stop="isDrawing ? handleCancelDraw() : handleAdd()"
                            :class="{ 'draw-button': true, 'draw-button-disabled': hasDrawn }" :disabled="hasDrawn" style="margin-right: 10px;">{{ isDrawing ? '取消绘制' : '绘制' }}</el-button>
                        <el-button size="small" @click.stop="handleClearDraw()"
                            :class="{ 'draw-button': true, 'draw-button-disabled': !hasDrawn }" :disabled="!hasDrawn">清除</el-button>
                    </div>
                    <div style="font-size: 12px; color: #333; background-color: #f5f5f5; padding: 10px; border-radius: 6px; border: 1px solid #ddd; line-height: 1.4; text-align: center;">
                        左键点击绘制<br>
                        右键撤回<br>
                        双击结束绘制自动闭合
                    </div>
                </div>
                <el-select v-model="saveElectronicFenceReq.type" placeholder="围栏类型" size="small" style="width: 120px; margin-right: 10px;">
                    <el-option label="还车围栏" :value="1"></el-option>
                    <el-option label="运营区域围栏" :value="2"></el-option>
                </el-select>
                <el-button type="success" size="small" @click.stop="saveElectronicFence()"
                    style="background-color: #3CA757;color: #FFFFFF;">保存</el-button>
                <el-button type="success" size="small" @click.stop="handDelete()"
                    style="background-color: #3CA757;color: #FFFFFF;">删除</el-button>
                <el-select v-if="isAdmin" class="distributor_select" :clearable=true
                    v-model="saveElectronicFenceReq.distributorId" :filterable=true placeholder="请选择运营商">
                    <el-option v-for="item in distributorOptions" :key="item.key" :label="item.value" :value="item.key">
                    </el-option>
                </el-select>
            </div>
            
            <div class="fence-legend">
                <div class="legend-title">围栏类型</div>
                <div class="legend-item">
                    <span class="legend-color return-color"></span>
                    <span class="legend-text">还车围栏</span>
                </div>
                <div class="legend-item">
                    <span class="legend-color operation-color"></span>
                    <span class="legend-text">运营区域</span>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
    data() {
        return {
            user: '',
            isAdmin: false,
            geometrieList: [],
            electronicFenceList: [],
            saveElectronicFenceReq: {
                distributorId: '',
                name: '',
                type: 1,
                saveElectronicFenceListReq: [],
            },
            hasDrawn: false,
            isDrawing: false,
            distributorInfo: {},
            distributorOptions: [],
            map: null,
            editor: null,
            markerLayer: null,
            multiLabel: null,
            queryDistributorId: ''
        }
    },
    mounted() {
        this.user = window.sessionStorage.getItem('user');
        this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
        this.queryDistributorId = getCurrentDistributorId()
        this.initDistributorInfo();
        // 确保 DOM 完全渲染后再加载电子围栏和初始化地图
        this.$nextTick(() => {
            setTimeout(() => {
                this.getElectronicFenceList();
            }, 100);
        });
    },
    beforeDestroy() {
        // 销毁地图
        if (this.map) {
            this.map.destroy()
            this.map = null
        }
    },
    methods: {
        initMap() {
            // 销毁旧地图
            if (this.map) {
                try {
                    this.map.destroy()
                } catch (e) {
                    console.warn('销毁地图失败:', e)
                }
                this.map = null
            }
            
            // 检查 DOM 元素是否存在
            const mapContainer = document.getElementById('map_view')
            if (!mapContainer) {
                console.error('地图容器元素不存在，稍后重试')
                setTimeout(() => {
                    this.initMap()
                }, 200)
                return
            }
            
            // 检查 TMap 是否存在
            if (typeof TMap === 'undefined') {
                console.error('TMap 未定义，稍后重试')
                setTimeout(() => {
                    this.initMap()
                }, 200)
                return
            }
            
            var center = new TMap.LatLng(32.916652, 117.358006)
            this.map = new TMap.Map(mapContainer, {
                center: center,
                zoom: 15
            });

            this.markerLayer = new TMap.MultiMarker({
                map: this.map,
                styles: {
                    highlight: new TMap.MarkerStyle({
                        color: 'rgba(255, 255, 0, 0.6)'
                    })
                },
            });

            this.editor = new TMap.tools.GeometryEditor({
                map: this.map,
                overlayList: [
                    {
                        id: 'polygon1',
                        selectedStyleId: 'highlight',
                        overlay: new TMap.MultiPolygon({
                            map: this.map,
                            styles: {
                                highlight: new TMap.PolygonStyle({
                                    color: 'rgba(255, 255, 0, 0.6)'
                                }),
                                returnStyle: new TMap.PolygonStyle({
                                    color: 'rgba(255, 107, 53, 0.3)',
                                    showBorder: true,
                                    borderColor: '#ff6b35',
                                    borderWidth: 2
                                }),
                                operationStyle: new TMap.PolygonStyle({
                                    color: 'rgba(60, 167, 87, 0.3)',
                                    showBorder: true,
                                    borderColor: '#3CA757',
                                    borderWidth: 2
                                })
                            },
                            geometries: this.geometrieList
                        })
                    },
                ],
                actionMode: TMap.tools.constants.EDITOR_ACTION.INTERACT,
                snappable: true,
                selectable: true,
                activeOverlayId: 'polygon1',
            });
            
            this.editor.on('draw_complete', geometry => {
                this.saveElectronicFenceReq.saveElectronicFenceListReq.push(geometry.paths);
                console.log('this.saveElectronicFenceReq', this.saveElectronicFenceReq);
                this.hasDrawn = true;
                this.isDrawing = false;
                this.editor.setActionMode(1);
            })

            let evtList = ['delete', 'adjust', 'split', 'union'];
            evtList.forEach(evtName => {
                if (evtName == 'delete') {
                    this.editor.on(evtName + '_complete', evtResult => {
                        console.log(evtName, evtResult);
                        this.deleteElectronicFenceList(evtResult);
                    });
                }
            });
            
            // 获取当前位置并设置地图中心
            this.getCurrentLocation();
        },
        getCurrentLocation() {
            // 优先使用腾讯地图定位服务
            if (typeof TMap !== 'undefined' && TMap.service) {
                const geolocation = new TMap.service.Geolocation();
                geolocation.getLocation().then(result => {
                    if (result && result.lat && result.lng) {
                        const currentCenter = new TMap.LatLng(result.lat, result.lng);
                        this.map.setCenter(currentCenter);
                        console.log('腾讯地图定位成功:', result.lat, result.lng);
                    }
                }).catch(error => {
                    console.warn('腾讯地图定位失败，尝试浏览器定位:', error);
                    this.getBrowserLocation();
                });
            } else {
                this.getBrowserLocation();
            }
        },
        getBrowserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const lat = position.coords.latitude;
                        const lng = position.coords.longitude;
                        const currentCenter = new TMap.LatLng(lat, lng);
                        this.map.setCenter(currentCenter);
                        console.log('浏览器定位成功:', lat, lng);
                    },
                    (error) => {
                        console.warn('浏览器定位失败:', error.message);
                    },
                    {
                        enableHighAccuracy: true,
                        timeout: 10000,
                        maximumAge: 0
                    }
                );
            } else {
                console.warn('浏览器不支持地理定位');
            }
        },
        handleAdd() {
            // 如果已经绘制完成，则不允许再次绘制
            if (this.hasDrawn) {
                return;
            }
            // 指定图层处于编辑状态
            // editor.setActiveOverlay("polygon1");
            this.editor.setActionMode(2);
            this.isDrawing = true;
            console.log("editor:", this.editor);
        },
        // 取消绘制
        handleCancelDraw() {
            // 切换到选择模式
            this.editor.setActionMode(1);
            this.isDrawing = false;
            console.log("取消绘制");
        },
        // 清除绘制的电子围栏（只清除当前绘制未保存的）
        handleClearDraw() {
            // 重置保存请求数据
            this.saveElectronicFenceReq.saveElectronicFenceListReq = [];
            // 重置状态
            this.hasDrawn = false;
            this.isDrawing = false;
            // 清除编辑器中当前绘制的几何图形
            if (this.editor) {
                try {
                    // 获取编辑器的覆盖物列表
                    let overlayList = this.editor.getOverlayList();
                    if (overlayList && overlayList.length > 0) {
                        // 获取第一个覆盖物
                        let overlay = overlayList[0].overlay;
                        if (overlay && overlay.setGeometries) {
                            // 只显示已保存的电子围栏
                            let savedGeometries = [];
                            if (this.electronicFenceList) {
                                for (let index in this.electronicFenceList) {
                                    let fence = this.electronicFenceList[index];
                                    let polygonPaths = fence.paths.map(function (point) {
                                        return new TMap.LatLng(point.lat, point.lng);
                                    });
                                    let styleId = (fence.type === 2) ? 'operationStyle' : 'returnStyle';
                                    savedGeometries.push({ 
                                        id: `fence_${fence.id || index}`,
                                        styleId: styleId,
                                        paths: polygonPaths 
                                    });
                                }
                            }
                            // 设置覆盖物的几何图形为已保存的围栏
                            overlay.setGeometries(savedGeometries);
                            console.log("清除未保存的几何图形成功");
                        }
                    }
                    // 切换到选择模式
                    this.editor.setActionMode(1);
                } catch (error) {
                    console.error("清除绘制失败:", error);
                }
            }
            console.log("清除绘制");
        },
        // 计算多边形中心点
        calculateCenter(paths) {
            let latSum = 0;
            let lngSum = 0;
            for (let i = 0; i < paths.length; i++) {
                latSum += paths[i].getLat();
                lngSum += paths[i].getLng();
            }
            return new TMap.LatLng(latSum / paths.length, lngSum / paths.length);
        },

        handDelete() {
            this.$confirm("确认删除已选中的电子围栏吗？", {
                title: "提示",
                type: 'warning',
            }).then(resc => {
                this.editor.delete();
            });
        },
        saveElectronicFence() {
            // 验证运营商选择
            if (this.isAdmin && !this.saveElectronicFenceReq.distributorId) {
                this.$message.error('请选择运营商');
                return;
            }
            
            // 弹出弹框让用户输入电子围栏名称
            this.$prompt('请输入电子围栏名称', '保存电子围栏', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: (value) => {
                    if (!value || value.trim() === '') {
                        return '请输入电子围栏名称';
                    }
                    return true;
                }
            }).then(({ value }) => {
                // 设置电子围栏名称
                this.saveElectronicFenceReq.name = value.trim();
                
                // 调用保存接口
                this.$http.post('/device/manager/table/save', this.saveElectronicFenceReq).then((res) => {
                    if (res.data.code != 200) return this.$message.error(res.data.msg);
                    this.$message.success(res.data.msg);
                    window.location.reload();
                });
            }).catch(() => {
                // 用户取消输入
                console.log('用户取消输入电子围栏名称');
            });
        },
        getElectronicFenceList() {
            this.geometrieList = []
            this.$http.get('/device/manager/table/getElectronicFenceList', {
                params: {
                    queryDistributorId: this.queryDistributorId
                }
            }).then((res) => {
                console.log("查询电子围栏：", res);
                if (res.data.code == 200) {
                    console.log('res.data.data', res.data.data);
                    this.electronicFenceList = res.data.data || [];
                    if (this.electronicFenceList && this.electronicFenceList.length > 0) {
                        for (let index in this.electronicFenceList) {
                            let fence = this.electronicFenceList[index];
                            var polygonPaths = fence.paths.map(function (point) {
                                return new TMap.LatLng(point.lat, point.lng);
                            });
                            let styleId = (fence.type === 2) ? 'operationStyle' : 'returnStyle';
                            this.geometrieList.push({ 
                                id: `fence_${fence.id || index}`,
                                styleId: styleId,
                                paths: polygonPaths 
                            });
                        }
                        console.log('this.geometrieList:', this.geometrieList)
                    }
                } else {
                    this.electronicFenceList = []
                    this.$message.error(res.data.msg || '查询电子围栏失败')
                }
                // 使用$nextTick确保DOM完全加载后再初始化地图
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initMap();
                        // 显示电子围栏名称
                        this.showElectronicFenceNames();
                    }, 100);
                });
            }).catch((error) => {
                console.error('获取电子围栏列表失败:', error)
                this.electronicFenceList = []
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.initMap();
                    }, 100);
                });
            })
        },
        // 显示电子围栏名称
        showElectronicFenceNames() {
            if (!this.electronicFenceList || this.electronicFenceList.length === 0) {
                return;
            }
            
            let labelGeometries = [];
            for (let index in this.electronicFenceList) {
                let fence = this.electronicFenceList[index];
                let polygonPaths = fence.paths.map(function (point) {
                    return new TMap.LatLng(point.lat, point.lng);
                });
                // 计算中心点
                let center = this.calculateCenter(polygonPaths);
                // 添加标签
                labelGeometries.push({
                    id: fence.id,
                    position: center,
                    content: fence.name || '未命名围栏',
                    styleId: 'label'
                });
            }
            
            // 创建新的MultiLabel实例
            if (this.multiLabel) {
                this.multiLabel.remove();
            }
            
            this.multiLabel = new TMap.MultiLabel({
                map: this.map,
                geometries: labelGeometries,
                styles: {
                    label: new TMap.LabelStyle({
                        color: '#FFFFFF',
                        size: 14,
                        backgroundColor: '#3CA757',
                        borderColor: '#FFFFFF',
                        borderWidth: 2,
                        borderRadius: 8,
                        padding: '10px',
                        offset: { x: 0, y: 0 }
                    })
                }
            });
        },
        deleteElectronicFenceList(evtResult) {
            console.log('deleteElectronicFenceList:', evtResult)
            this.$http.post('/device/manager/table/deleteElectronicFenceList', evtResult).then((res) => {
                console.log("删除电子围栏：", res);
                if (res.data.code != 200) return this.$message.error(res.data.msg);
                this.$message.success(res.data.msg);
                window.location.reload();
            });
        },
        initDistributorInfo() {
            if (this.isAdmin) {
                this.distributorInfo = {};
                this.$http.get('/distributor/manager/switchList').then((res) => {
                    this.distributorOptions = [];
                    if (res.data.code != 200) return this.$message.error(res.data.msg);
                    let distributorInfoList = res.data.data || [];
                    for (let index in distributorInfoList) {
                        this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
                    }
                    console.log('this.distributorOptions：', this.distributorOptions);
                });
            }
        },
		// switchToSatelliteMap() {
        //     // 切换到卫星地图
        //     map.setMapTypeId('satellite');  // 使用'satellite'图层样式
		// }

    },
}

</script>
<style scoped>
#container {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
}

#map_view {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

#edit_view {
    display: flex;
    position: absolute;
    left: 65%;
    top: 2%;
    z-index: 2000;
}

.draw-button {
    border: none;
}

.draw-button:hover {
    background-color: #3CA757;
    color: #FFFFFF;
    border: none;
}

.draw-button:active {
    background-color: #3CA757 !important;
    color: #FFFFFF !important;
    border: none !important;
}

.draw-button:focus {
    background-color: #3CA757 !important;
    color: #FFFFFF !important;
    border: none !important;
    outline: none !important;
}

.draw-button:disabled,
.draw-button-disabled {
    background-color: #CCCCCC !important;
    color: #FFFFFF !important;
    border: none !important;
    cursor: not-allowed !important;
}

.distributor_select {
    margin-left: 10px;
}

.fence-legend {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 9999;
    background-color: white;
    padding: 12px 16px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.legend-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
}

.legend-item {
    display: flex;
    align-items: center;
    margin-top: 8px;
}

.legend-color {
    width: 20px;
    height: 14px;
    border-radius: 3px;
    margin-right: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.return-color {
    background-color: #ff6b35;
}

.operation-color {
    background-color: #3CA757;
}

.legend-text {
    font-size: 13px;
    color: #666;
}
</style>